import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { CenteredFlexColumn, CenteredFlexRow, FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon } = colorsPalettes;

const ChartContainer = styled(FlexColumn)`
    flex-grow: 1;
    height: 100%;
    gap: 30px;
    justify-content: space-between;
    padding: 16px 4px 16px 16px;
`;

const LoaderContainer = styled(CenteredFlexColumn)`
    height: 340px;
    width: 100%;
`;

const LegendsContainer = styled.div`
    float: right;
    width: 235px;
    min-width: 235px;
    padding: 24px 16px 0px 18px;
    height: 100%;
    flex: 1 1 auto;
`;

const NoDataContainer = styled(CenteredFlexRow)`
    width: 100%;
    align-content: center;
    height: 500px;
`;

export const DemandOverTimeWrapper = styled.div`
    margin-bottom: 24px;
`;

const Header = styled(FlexRow)`
    justify-content: space-between;
    padding: 12px 12px 12px 24px;
    border-bottom: 1px solid ${carbon[50]};
    align-items: center;
`;
